module.exports = __webpack_public_path__ + "static/img/che08.0247970.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/che08.png
// module id = lzcy
// module chunks = 1